import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Breadcrumb,
  Button,
  Modal,
} from "react-bootstrap";
import { Helmet } from "react-helmet";

// Assume all necessary image imports are here (as provided in the previous turn)
import banner from "../assets/images/landing/intranet-banner.jpg";
import bannermobile from "../assets/images/landing/intranet-banner.jpg";
import lifeicon from "../assets/images/lifeaticon.png";
import total from "../assets/images/Total-Rewards.png";
import learning from "../assets/images/learning-Development.png";
import employee from "../assets/images/EmployeeEngament.png";
import job from "../assets/images/growth-accelerator.png";
import smarticon from "../assets/images/smarticon.png";
import smarticon1 from "../assets/images/smarticon1.png";
import smarticon2 from "../assets/images/smarticon2.png";
import awardCommon from "../assets/images/awardCommon.jpg";

import Slider from "react-slick";
import { withTranslation } from "react-i18next";

// --- Constants ---
const IMAGE_BASE_URL = "https://admin.nuvoco.com/";

// Map API categories (lowercase) to their icons/local names
const CATEGORY_MAP = {
  safer: { nameKey: "Safer", icon: smarticon },
  smarter: { nameKey: "Smarter", icon: smarticon1 },
  sustainable: { nameKey: "Sustainable", icon: smarticon2 }, // Assuming 'sustainable' is also a possibility
};

const settings = {
  //autoplay:true,
  autoplaySpeed: 2000,
  dots: false,
  arrow: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

class LifeatNuvoco extends React.Component {
  constructor(props) {
    super(props); // FIX 1: Passed props to super()
    this.state = {
      // State for dynamic data (FIX 2: Restored complete state)
      awardsData: {},
      isLoading: true,
      error: null,
      // Holds the currently selected year string (e.g., '2024')
      activeYear: null,
      // Keep existing state for modals and disclaimer
      isOpen1: false,
      isOpen2: false,
      isOpen3: false,
      isOpen4: false,
      disclaimer: false,
    };
    this.setActiveYear = this.setActiveYear.bind(this);
    this.fetchAwardsData = this.fetchAwardsData.bind(this);
    // Note: hideComponent binding removed as it was defined but empty.
  }

  componentDidMount() {
    this.fetchAwardsData();
    setTimeout(() => {
      this.setState({ disclaimer: true });
    }, 3000);
  }

  async fetchAwardsData() {
    try {
      const response = await fetch(
        "https://admin.nuvoco.com/api/awards-recognition-grouped"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch awards data.");
      }
      const result = await response.json();

      // Check if status is true and data exists
      if (!result.status || !result.data) {
        throw new Error("API returned success status false or no data.");
      }

      const rawData = result.data;
      const processedData = {};

      // Process the raw data to prepend the base URL to images and rename keys
      Object.keys(rawData).forEach((year) => {
        processedData[year] = {};
        const yearData = rawData[year];

        Object.keys(yearData).forEach((category) => {
          const awards = yearData[category];
          // Map over awards in the category to transform the structure
          processedData[year][category] = awards.map((award) => ({
            ...award,
            // Prepend base URL for valid image source
            image_url: award.award_image
              ? `${IMAGE_BASE_URL}${award.award_image}`
              : null,
            // Normalize the misspelled description field name
            description: award.awaward_desc,
          }));
        });
      });

      // Inject static 2026 awards
      if (!processedData["2026"]) {
        processedData["2026"] = {};
      }
      processedData["2026"]["smarter"] = [
        ...(processedData["2026"]["smarter"] || []),
        {
          id: "2026-smarter-1",
          award_img_title: "Radio Mirchi Business Class Awards",
          image_url: null,
          description: "Nuvoco was honoured at the Radio Mirchi Business Class Awards held in Bali, Indonesia, for its innovation in construction materials."
        },
        {
          id: "2026-smarter-2",
          award_img_title: "BAM Awards",
          image_url: null,
          description: "Recognition at BAM Awards for Mera Bharosa Nuvoco Zero M IWC+ Campaign"
        }
      ];
      
      processedData["2026"]["sustainable"] = [
        ...(processedData["2026"]["sustainable"] || []),
        {
          id: "2026-sustainable-1",
          award_img_title: "36th MEMC Awards",
          image_url: null,
          description: "Chittor Cement Plant (CCP) Honoured at the 36th Mines Environment & Mineral Conservation Awards."
        },
        {
          id: "2026-sustainable-2",
          award_img_title: "9th MEMC Award Ceremony",
          image_url: null,
          description: "Sonadih Limestone Mines Felicitated at 9th MEMC Award Ceremony."
        }
      ];

      // Get years and sort them in descending order (latest year first)
      const years = Object.keys(processedData).sort(
        (a, b) => parseInt(b) - parseInt(a)
      );
      const latestYear = years.length > 0 ? years[0] : null;

      this.setState({
        awardsData: processedData,
        activeYear: latestYear, // Set the latest year as active by default
        isLoading: false,
        error: null,
      });
    } catch (error) {
      console.error("Error fetching awards:", error);
      this.setState({
        error: `Failed to load awards data: ${error.message}`,
        isLoading: false,
      });
    }
  }

  // New year selection function (replaces hideComponent for year tabs)
  setActiveYear(year) {
    this.setState({ activeYear: year });
  } // Keep all modal functions

  openModal1 = () => this.setState({ isOpen1: true });
  closeModal1 = () => this.setState({ isOpen1: false });
  openModal2 = () => this.setState({ isOpen2: true });
  closeModal2 = () => this.setState({ isOpen2: false });
  openModal3 = () => this.setState({ isOpen3: true });
  closeModal3 = () => this.setState({ isOpen3: false });
  openModal4 = () => this.setState({ isOpen4: true });
  closeModal4 = () => this.setState({ isOpen4: false });
  disclaimer = () => this.setState({ disclaimer: true });
  closeDisclaimer = () => this.setState({ disclaimer: false });

  // Helper method to render an award category block
  renderAwardCategory = (category, awards, t) => {
    if (!awards || awards.length === 0) return null;

    const categoryInfo = CATEGORY_MAP[category];

    if (!categoryInfo) return null; // Skip if category is not mapped

    return (
      <Col
        md={6}
        lg={4}
        className="wow fadeInUp mb-4 lifeatnuvocosmartMain align-items-center"
        data-wow-delay="0.5s"
      >
        <div className="lifeatnuvocosmart justify-content-center row">
          {/* Assuming the category name keys are defined in your language files, using nameKey (e.g., 'Safer') */}
          <h4 className="row">
            {t(`life_at_nuvoco.awards.${categoryInfo.nameKey}`)}
          </h4>
          <img src={categoryInfo.icon} alt={`${categoryInfo.nameKey} icon`} />
        </div>
        <Slider {...settings}>
          {awards.map((award, index) => (
            <Card key={`${category}-${index}`}>
              {/* Use the dynamically created image_url */}
                  <div className="img-wrapper position-relative" style={{ overflow: "hidden" }}>
                    <span style={{
                      position: "absolute",
                      inset: 0,
                      backgroundImage: "url('" + (award.image_url || awardCommon) + "')",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: "100%",
                      width: "100%",
                      filter: "blur(10px)",
                      transform: "scale(1.2)", // Scale up slightly to prevent blur from exposing edges
                      zIndex: 0
                    }}></span>
                    <Card.Img
                      variant="top"
                      src={award.image_url || awardCommon}
                      alt={award.award_img_title || "Award image"}
                      style={{
                        maxHeight: "240px",
                        objectFit: "scale-down",
                        height: "100%",
                        width: "100%",
                        position: "relative",
                        zIndex: 1,
                        background: "transparent",
                      }}
                      // Simple error handling for images
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = awardCommon;
                      }}
                    />
                  </div>
              <Card.Body style={{ fontSize: "1rem" }}>
                {/* Use dangerouslySetInnerHTML for HTML content in the description */}
                <p
                  dangerouslySetInnerHTML={{
                    __html: award.description || award.award_img_title,
                  }}
                ></p>
              </Card.Body>
            </Card>
          ))}
        </Slider>
      </Col>
    );
  };

  render() {
    const { t } = this.props;
    const { awardsData, isLoading, error, activeYear } = this.state;

    // Get years and sort them for the buttons (latest year first)
    const years = Object.keys(awardsData).sort(
      (a, b) => parseInt(b) - parseInt(a)
    );
    const activeAwards = awardsData[activeYear];

    return (
      <div className="aboutus-pge inner_page lifeatnuvocopage">
        <Helmet>
          <title>{t("SEO.lifeNuvoco.title")}</title>
          <meta name="keywords" description="" />
          <meta name="description" content={t("SEO.lifeNuvoco.desc")} />
          <link
            rel="canonical"
            href={window.location.origin + window.location.pathname}
          />
          <link
            rel="alternate"
            hreflang="en"
            href={t("SEO.lifeNuvoco.alternateLinks.en")}
          />
          <link
            rel="alternate"
            hreflang="gu"
            href={t("SEO.lifeNuvoco.alternateLinks.guj")}
          />
          <link
            rel="alternate"
            hreflang="hi"
            href={t("SEO.lifeNuvoco.alternateLinks.hi")}
          />
          <link
            rel="alternate"
            hreflang="x-default"
            href={t("SEO.lifeNuvoco.canLink")}
          />
        </Helmet>
        {/* Banner and Breadcrumb section */}
        <div className="banner text-center position-relative">
          <img className="desktopbannerinner" src={banner} alt="" />
          <img className="mobilebannerinner w-100" src={bannermobile} alt="" />
          <article className="position-absolute text-center" style={{ opacity: 0 }}>
            <span className="d-flex justify-content-center align-items-center mx-auto">
              <img src={lifeicon} alt="" />
            </span>
            <h1 className="text-uppercase">{t("life_at_nuvoco.pageTitle")}</h1>
          </article>
          <div className="breadouter">
            <div className="container">
              <Breadcrumb className="mb-0 py-2">
                <Breadcrumb.Item href="#">
                  {t("breadcrumb.home")}
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                  {t("life_at_nuvoco.pageTitle")}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
        </div>

        <div className="midpart mb-5">
          <Container>
            <Row>
              <Col md={5}>
                <h2 className="grad-heading">{t("life_at_nuvoco.title")}</h2>
                <p>{t("life_at_nuvoco.desc1")}</p>
                <p>{t("life_at_nuvoco.desc2")}</p>
                <p>{t("life_at_nuvoco.desc3")} </p>
              </Col>

              <Col md={7} className="lifemiddle">
                <Row>
                  {/* Key Pillars */}
                  <Col
                    className="wow fadeInUp mb-4"
                    md={6}
                    data-wow-delay="0.5s"
                  >
                    <Card onClick={this.openModal1}>
                      <Card.Img variant="top" src={total} />
                      <Card.Body>
                        <Card.Title className="g_invert">
                          {t("home.life_nuvoco.totla_rewards")}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col
                    className="wow fadeInUp mb-4"
                    md={6}
                    data-wow-delay="0.6s"
                  >
                    <Card onClick={this.openModal2}>
                      <Card.Img variant="top" src={learning} />
                      <Card.Body>
                        <Card.Title className="g_invert">
                          {t("home.life_nuvoco.learning_development")}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col className="wow fadeInUp" md={6} data-wow-delay="0.7s">
                    <Card onClick={this.openModal3}>
                      <Card.Img variant="top" src={employee} />
                      <Card.Body>
                        <Card.Title className="g_invert">
                          {t("home.life_nuvoco.employee_engagement")}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col className="wow fadeInUp" md={6} data-wow-delay="0.8s">
                    <Card onClick={this.openModal4}>
                      <Card.Img variant="top" src={job} />
                      <Card.Body>
                        <Card.Title className="g_invert">
                          {t("home.life_nuvoco.growth_accelerator")}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="award mt-5">
              <Row>
                <Col>
                  <h2 className="grad-heading">
                    {t("life_at_nuvoco.awards.title")}
                  </h2>

                  <Container className="text-center LifeTab">
                    {/* Dynamic Year Buttons based on fetched data */}
                    <div className="mb-4 d-flex justify-content-center flex-wrap">
                      {years.reverse().map((year) => (
                        <Button
                          key={year}
                          onClick={() => this.setActiveYear(year)}
                          variant="success"
                          className={`mx-2 my-1 ${activeYear === year ? "active" : ""
                            }`}
                        >
                          {year}
                        </Button>
                      ))}
                    </div>
                    {/* Loading, Error, and Content display logic */}
                    {isLoading && (
                      <p className="text-center">Loading awards data...</p>
                    )}
                    {error && (
                      <p className="text-danger text-center">{error}</p>
                    )}
                    {!isLoading && activeAwards && (
                      <div className="card_round lifemt">
                        <Row className="justify-content-center mb-3">
                          <Col md={12} className="lifemiddle">
                            <Row className="justify-content-center">
                              {/* Render award categories dynamically (safer, smarter, sustainable) */}
                              {Object.keys(activeAwards).map((categoryKey) =>
                                this.renderAwardCategory(
                                  categoryKey,
                                  activeAwards[categoryKey],
                                  t
                                )
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    )}
                    {!isLoading && !activeAwards && activeYear && (
                      <p className="text-center">
                        No awards listed for the year {activeYear}.
                      </p>
                    )}
                    {!isLoading && years.length === 0 && (
                      <p className="text-center">No awards data available.</p>
                    )}
                  </Container>
                </Col>
              </Row>
            </div>
            <div className="mt-5 fakeEmployment">
              <Row>
                <Col>
                  <h2 className="grad-heading">
                    {t("life_at_nuvoco.fake_desclaimer")}
                  </h2>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t("life_at_nuvoco.fake_desc"),
                    }}
                  ></p>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        {/* Modals and CareerForm (keeping existing structure) */}
        <Modal
          size="lg"
          centered="true"
          show={this.state.isOpen1}
          onHide={this.closeModal1}
          className="productbob_modal bob_modal1 product_modal our_brand_inner card_round"
        >
          <Modal.Body>
            <Modal.Header closeButton></Modal.Header>
            <Row>
              <Col md={12}>
                <div className="align-item-center lifepopupdesign">
                  <article className="p-4">
                    <h4>{t("home.life_nuvoco.totla_rewards")}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("home.life_nuvoco.totla_rewards_desc"),
                      }}
                    ></p>
                  </article>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          centered="true"
          show={this.state.isOpen2}
          onHide={this.closeModal2}
          className="productbob_modal bob_modal1 product_modal our_brand_inner card_round"
        >
          <Modal.Body>
            <Modal.Header closeButton></Modal.Header>
            <Row>
              <Col md={12}>
                <div className="align-item-center lifepopupdesign">
                  <article className="p-4">
                    <h4>{t("home.life_nuvoco.learning_development")}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("home.life_nuvoco.learning_development_desc"),
                      }}
                    ></p>
                  </article>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          centered="true"
          show={this.state.isOpen3}
          onHide={this.closeModal3}
          className="productbob_modal bob_modal1 product_modal our_brand_inner card_round"
        >
          <Modal.Body>
            <Modal.Header closeButton></Modal.Header>
            <Row>
              <Col md={12}>
                <div className="align-item-center lifepopupdesign">
                  <article className="p-4">
                    <h4>{t("home.life_nuvoco.employee_engagement")}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("home.life_nuvoco.employee_engagement_desc"),
                      }}
                    ></p>
                  </article>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          centered="true"
          show={this.state.isOpen4}
          onHide={this.closeModal4}
          className="productbob_modal bob_modal1 product_modal our_brand_inner card_round"
        >
          <Modal.Body>
            <Modal.Header closeButton></Modal.Header>
            <Row>
              <Col md={12}>
                <div className="align-item-center lifepopupdesign">
                  <article className="p-4">
                    <h4>{t("home.life_nuvoco.growth_accelerator")}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("home.life_nuvoco.growth_accelerator_desc"),
                      }}
                    ></p>
                  </article>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          centered="true"
          show={this.state.disclaimer}
          onHide={this.closeDisclaimer}
          className="bob_modal bob_modal1 product_modal our_brand_inner card_round"
        >
          <Modal.Body>
            <Modal.Header closeButton></Modal.Header>
            <Row>
              <Col md={12} className="d-flex align-items-center">
                <h2 className="grad-heading">
                  {t("life_at_nuvoco.fake_desclaimer")}
                </h2>
              </Col>
              <Col md={12}>
                <div className="d-flex align-item-center">
                  <article className="p-4">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("life_at_nuvoco.fake_desc"),
                      }}
                    ></p>
                  </article>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        {/* <div className="contact_us_form pt-0">
          <Container>
            <Row>
              <Col md={12}>
                <div className="bg-light-gray position-relative text-center mx-auto mt-4 careerFormMain">
                  <img src={contact_icon} className="icon mx-auto" alt="" />
                  <CareerForm formTitle="careers.form_title" />
                </div>
              </Col>
            </Row>
          </Container>
        </div> */}
      </div>
    );
  }
}

export default withTranslation()(LifeatNuvoco);
